import { Routes, Route } from "react-router-dom";
import { Suspense } from "react";
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { routes } from "./routes/route";
import { SidebarProvider } from "./components/layouts/SidebarContext";
import { PushNotificationsManager } from "./features/notifications";
import PwaRefreshButton from "./components/layouts/PwaRefreshButton";

const queryClient = new QueryClient();

function App() {
  return (
    <SidebarProvider>
      <QueryClientProvider client={queryClient}>
        <>
          <PushNotificationsManager />
          <PwaRefreshButton/>
          <ToastContainer position="bottom-right" />
          <Suspense fallback={<div className="flex items-center justify-center h-screen"><div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div></div>}>
            <Routes>
              {routes.map(({ path, element }, index) => (
                <Route
                  key={index}
                  path={path}
                  element={element}
                />
              ))}
            </Routes>
          </Suspense>
        </>
      </QueryClientProvider>
    </SidebarProvider>
  );
}

export default App;
